import { useEffect } from "react";
import { useParams } from "react-router";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import LabReportInterpretationTable from "@/app/components/routes/auth_routes/LabReportInterpretation/LabReportInterpretationTable";
import { useLabReportInterpretationPetListAPI } from "@/app/hooks/api_hooks/LabReportInterpretation/useLabReportInterpretationPetListAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ROUTES } from "@/app/routes";
import { useAppSelector } from "@/app_redux/hooks/root_hook";

const LabInterpretationTab = () => {
  const { user_id, pet_id } = useParams();
  const { routeState } = useRouteInfo(ROUTES.ROOT.children.CUSTOMER_PROFILE.id);
  const { customerId, petId } = routeState.state as ICustomerProfileState;
  const { mappedClinicId } = useAppSelector((state) => state.root.UIStates);
  const { execute: fetchPetInterpretations, data, loading, error } = useLabReportInterpretationPetListAPI();

  const activeCustomerId = customerId ?? user_id;
  const activePetId = petId ?? pet_id;

  const refreshPetInterpretations = () => {
    if (activeCustomerId && activePetId) {
      fetchPetInterpretations({
        customer_id: activeCustomerId,
        pet_id: activePetId,
        clinic_ids: mappedClinicId ? [mappedClinicId] : [],
      });
    }
  };

  useEffect(() => {
    refreshPetInterpretations();
  }, [activeCustomerId, activePetId, mappedClinicId]);

  return (
    <div className="px-0">
      <div className="px-2 mb-2">
        <h1 className="text-sm font-semibold leading-6 text-gray-900">Lab Interpretations</h1>
      </div>
      <div className="px-2">
        {activePetId ? (
          <LabReportInterpretationTable
            rows={data}
            loading={loading}
            error={error}
            onRefresh={refreshPetInterpretations}
          />
        ) : (
          <p className="py-10 text-center text-sm text-gray-500">Select a pet to see its lab interpretations.</p>
        )}
      </div>
    </div>
  );
};

export default LabInterpretationTab;
